import { query } from '@confluence/query-preloader-tools';

import { TitleContentPropertyQuery, HomepageIdQuery } from './TitleContentPropertyQuery.graphql';
import type {
	HomepageIdQuery as HomepageIdQueryType,
	HomepageIdQueryVariables,
} from './__types__/HomepageIdQuery';

const preloadHomepageId = (spaceKey: string) =>
	query<HomepageIdQueryType, HomepageIdQueryVariables>({
		query: HomepageIdQuery,
		variables: {
			spaceKey,
		},
	});

const preloadTitleContentProperty = (contentId: string) =>
	query({
		query: TitleContentPropertyQuery,
		variables: {
			contentId,
			status: ['current', 'draft', 'archived'],
		},
	});

export const preloadPageTitleContentProperties = async ({
	contentId,
	spaceKey,
}: {
	contentId: string;
	spaceKey: string;
}) => {
	const promises: Promise<any>[] = [];
	if (!contentId) {
		promises.push(
			preloadHomepageId(spaceKey).then((res) => {
				const homepageId = res?.data?.space?.homepage?.id;
				if (homepageId) {
					return preloadTitleContentProperty(homepageId);
				}
			}),
		);
	} else {
		promises.push(preloadTitleContentProperty(contentId));
	}

	return Promise.all(promises);
};
